import {
    CHANGE_FILTERS,
    FETCH_DATA,
    LOADING,
    NEW,
    UPDATE,
} from '../actions/stocks';
import {
    getDefaultListForRegion,
    getDefaultList,
    getDefaultMarket,
} from '../service/stocks';
import defaultFilters from '../../../config/filters';

const initialState = {
    isFetching: false,
    filters: defaultFilters,
    symbols: [],
};

export default function stocks(state = initialState, action) {
    switch (action.type) {
    case FETCH_DATA.REQUEST:
        return Object.assign({}, state, {
            isFetching: true,
        });

    case FETCH_DATA.SUCCESS:
        return Object.assign({}, state, {
            isFetching: false,
            symbols: action.payload,
        });

    case FETCH_DATA.FAILURE:
        return Object.assign({}, state, {
            isFetching: false,
        });

    case NEW:
        return Object.assign({}, state, {
            isFetching: false,
            symbols: action.payload,
        });

    case UPDATE:
        return Object.assign({}, state, {
            symbols: state.symbols.map(symbol => {
                if (symbol.key === action.key) {
                    return {
                        key: symbol.key,
                        values: Object.assign({}, symbol.values, action.values),
                    };
                }

                return symbol;
            }),
        });

    case LOADING:
        return Object.assign({}, state, {
            isFetching: true,
        });

    case CHANGE_FILTERS: {
        let filters = state.filters;

        if (action.filters) {
            Object.keys(action.filters).forEach(key => {
                switch (key) {
                case 'period': {
                    const period = action.filters[key];
                    filters = Object.assign({}, filters, { period });
                    break;
                }
                case 'region': {
                    const region = action.filters[key];
                    filters = Object.assign({}, filters, {
                        region,
                        market: getDefaultMarket(region).id || null,
                        list: getDefaultListForRegion(region).id || null,
                        symbols: [],
                    });
                    break;
                }
                case 'market': {
                    const market = action.filters[key];
                    filters = Object.assign({}, filters, {
                        market,
                        list: getDefaultList(market).id || null,
                        symbols: [],
                    });
                    break;
                }
                case 'list': {
                    const list = action.filters[key];
                    filters = Object.assign({}, filters, {
                        list,
                        symbols: [],
                    });
                    break;
                }
                case 'sort': {
                    const sort = action.filters[key];
                    filters = Object.assign({}, filters, { sort });
                    break;
                }
                default:
                    break;
                }
            });
        }

        return Object.assign({}, state, { filters });
    }

    default:
        return state;
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/redux/stocks.js
 **/